import { Grid } from '@material-ui/core';
import React from 'react';

const SectionHeader = ({
  //
  title,
  textAlign = 'left',
  fontSize = 30,
  fontWeight = 'bold',
  color = 'var(--jmi-blue)',

  containerStyle,
  containerClass,
  textStyle,
  textClass,

  xs = 12,
  sm,
  md,
  lg,
  xl,
}) => {
  return (
    <Grid
      item
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      style={{ textAlign, ...containerStyle }}
      className={containerClass}
    >
      <span
        style={{
          fontSize,
          fontWeight,
          color,
          ...textStyle,
        }}
        className={textClass}
      >
        {title}
      </span>
    </Grid>
  );
};

export default SectionHeader;
